import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertObjectsFormValueToKnmData = (
  objects: IKnmErknmForm['objectsErknm'],
  isNewKnm?: boolean,
  isDraft?: boolean,
): IKnm248['objects'] => {
  if (!objects) {
    return null;
  }

  return objects.map(item => {
    const { objectKind, objectSubKind } = item;
    const objectSubKindByKind = objectKind?.analogue ? objectKind : objectSubKind;

    return {
      address: item.address || null,
      objectType: item.objectType?.value || null,
      objectKind: item.objectKind?.value || null,
      objectSubKind: isNewKnm ? objectSubKindByKind?.value || null : objectSubKind?.value || null,
      riskCategory: item.riskCategory?.value || null,
      dangerClass: item.dangerClass?.value || null,
      guid: item.guid || null,
      ervkNumber: item.ervkNumber || null,
      ervkId: item.ervkId || null,
      cosId: item.cosId || null,
      cosVersion: item.cosVersion || null,
      name: item.name || null,
      streetGuid: item.streetGuid || null,
      houseGuid: item.houseGuid || null,
      roomGuid: item.roomGuid || null,
      steadGuid: item.steadGuid || null,
      addressFns: item.addressFns || null,
      autocomplete: typeof item.autocomplete === 'boolean' ? item.autocomplete : null,
      dateCreate: item.dateCreate || null,
      geolocation: item.geolocation || null,
      manualAddress: item.manualAddress || null,
      notInFIAS: item.notInFIAS || null,
      region: item.region ? item.region.id?.toString() : null,
      fiasRegion: item.fiasRegion ? item.fiasRegion.id?.toString() : null,
      regionName: item.regionName || null,
      organizationErvkId: item.organizationErvkId || null,
      inspectionResults: item.inspectionResults,
      tmpErvkCosId: null,
      isNew: isDraft ? item.isNew : null,
      updating: item.updating || null,
      isFilledFromLink: item.isFilledFromLink || null,
    };
  });
};
